export default __webpack_public_path__ + "static/media/2_yield_planet.6cbb37c3.svg";